import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
/**
 * Formatea una fecha al formato estándar: "05 Oct 2025"
 * @param date - Fecha a formatear (string, Date, null o undefined)
 * @returns Fecha formateada o "—" si no es válida
 */
export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return "—";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "—";
  // Formato: 05 Oct 2025
  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };
  const formatted = d.toLocaleDateString("es-ES", options);
  // Capitalizar primera letra del mes (oct -> Oct)
  // En español el formato suele ser "05 oct 2025". Haremos que coincida con "05 Oct 2025"
  return formatted.replace(/\b([a-z])/g, (match) => match.toUpperCase());
}
